import React from "react";

export const CartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M1.54543 14.455C0.687429 11.023 0.258429 9.308 1.15943 8.154C2.06043 7 3.82943 7 7.36643 7H11.9964C15.5344 7 17.3024 7 18.2034 8.154C19.1044 9.308 18.6754 11.024 17.8174 14.455C17.2714 16.638 16.9994 17.729 16.1854 18.365C15.3714 19 14.2464 19 11.9964 19H7.36643C5.11643 19 3.99143 19 3.17743 18.365C2.36343 17.729 2.09043 16.638 1.54543 14.455Z"
        stroke="#ABCDEC"
        stroke-width="1.2"
      />
      <path
        d="M17.1816 7.5L16.4716 4.895C16.1976 3.89 16.0606 3.388 15.7796 3.009C15.4995 2.63246 15.119 2.3424 14.6816 2.172C14.2416 2 13.7216 2 12.6816 2M2.18164 7.5L2.89164 4.895C3.16564 3.89 3.30264 3.388 3.58364 3.009C3.86382 2.63246 4.24433 2.3424 4.68164 2.172C5.12164 2 5.64164 2 6.68164 2"
        stroke="#ABCDEC"
        stroke-width="1.2"
      />
      <path
        d="M6.68164 2C6.68164 1.73478 6.787 1.48043 6.97453 1.29289C7.16207 1.10536 7.41642 1 7.68164 1H11.6816C11.9469 1 12.2012 1.10536 12.3887 1.29289C12.5763 1.48043 12.6816 1.73478 12.6816 2C12.6816 2.26522 12.5763 2.51957 12.3887 2.70711C12.2012 2.89464 11.9469 3 11.6816 3H7.68164C7.41642 3 7.16207 2.89464 6.97453 2.70711C6.787 2.51957 6.68164 2.26522 6.68164 2Z"
        stroke="#ABCDEC"
        stroke-width="1.2"
      />
    </svg>
  );
};
